import React, { useEffect, useState } from 'react';
import { getLocal, setLocal, LocalStorageKeys } from '../../utils/localStorage';
import { getStoredRecentlyViewedSkus } from '../../utils/storedRecentlyViewedSkus';
import { RecentSearches } from './RecentSearches';
import { RecentlyViewedResultsWrapper } from './RecentlyViewedProducts';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';
import { pushToDataLayer } from '@jbhi-fi/utils/src/ga4Tracking/datalayer';
import { JBButton } from '@jbhi-fi/lanyard-ui';
import DeleteIcon from '@jbhi-fi/lanyard-ui/components/Icons/Delete';

interface QuickSuggestionsProps {
  onSearch: (searchTerm: string, source: string, searchOptions: any, shouldUpdateUrl: boolean) => void;
  searchTerm: string;
}

const QuickSuggestions = ({ onSearch }: QuickSuggestionsProps) => {
  const [storedSearches, setStoredSearches] = useState(JSON.parse(getLocal(LocalStorageKeys.RecentSearches)) || []);
  const recentlyViewedSkus = getStoredRecentlyViewedSkus();

  useEffect(() => {
    setLocal(LocalStorageKeys.RecentSearches, JSON.stringify(storedSearches));
  }, [storedSearches]);

  const clearAllSearches = (e: React.MouseEvent) => {
    pushToDataLayer({
      event: 'clear_search',
      method: 'all recent searches',
    });
    e.preventDefault();
    setStoredSearches([]);
  };

  if (storedSearches.length <= 0 && recentlyViewedSkus.length <= 0) {
    return <></>;
  }

  return (
    <div className="search-quick-suggestions">
      {storedSearches.length > 0 && (
        <div className="recent-searches">
          {storedSearches.length > 0 && (
            <JBButton
              label="Clear"
              type="linkWithIcon"
              iconPosition="left"
              icon={<DeleteIcon />}
              classes="clear-all"
              onClick={clearAllSearches}
            />
          )}
          <CalloutFont as="h3">Recent Searches</CalloutFont>
          <ul>
            <RecentSearches onSearch={onSearch.bind(this)} storedSearches={storedSearches} />
          </ul>
        </div>
      )}
      {recentlyViewedSkus.length > 0 && (
        <div className="recently-viewed">
          <CalloutFont as="h3">Recently Viewed</CalloutFont>

          <div className="product-suggestions--container">
            <RecentlyViewedResultsWrapper storedProducts={recentlyViewedSkus} />
          </div>
        </div>
      )}
    </div>
  );
};

export default QuickSuggestions;
